export default "__VITE_ASSET__0a040b26__"